import React, { memo, Suspense, useState } from 'react';
import { useDispatch } from 'react-redux';
import useFetchModels from '../../hooks/models/useFetchModels';
import { setSelectedModelAction } from '../../redux/actions/modelsActions';
import CommonLoader from '../shared/loaders/CommonLoader';
import EmptyContent from '../shared/table/EmptyContent';
import DeleteModelModal from './modals/DeleteModelModal';
import UpdateModelModal from './modals/UpdateModelModal';
import ModelsTable from './ModelsTable';

const ModelsList = ({ readOnly }) => {
  const dispatch = useDispatch();
  const { loading, models, refresh } = useFetchModels({ unpaged: false });
  const [showUpdateModelModal, setShowUpdateModelModal] = useState(false);
  const [showDeleteModelModal, setShowDeleteModelModal] = useState(false);

  const handleModelClick = (model) => {
    dispatch(setSelectedModelAction(model));
    setShowUpdateModelModal(true);
  };

  const handleUpdateModelModalSubmit = async () => {
    refresh();
    setShowUpdateModelModal(false);
  };

  const handleModelDeleteClick = (model) => {
    dispatch(setSelectedModelAction(model));
    setShowDeleteModelModal(true);
  };

  const handleDeleteModelModalSubmit = async () => {
    refresh();
    setShowDeleteModelModal(false);
  };

  return (
    <Suspense fallback={<CommonLoader />}>
      <div className="flex flex-col items-center">
        {showUpdateModelModal && (
          <UpdateModelModal
            readOnly={readOnly}
            onModalSubmit={() => handleUpdateModelModalSubmit()}
            onModalClose={() => setShowUpdateModelModal(false)}
          />
        )}
        {showDeleteModelModal && (
          <DeleteModelModal
            onModalSubmit={() => handleDeleteModelModalSubmit()}
            onModalClose={() => setShowDeleteModelModal(false)}
          />
        )}
        <>
          <ModelsTable
            onModelClick={handleModelClick}
            onModelDeleteClick={handleModelDeleteClick}
            models={models}
            readOnly={readOnly}
            loading={loading}
          />
          {models.length === 0 && !loading && <EmptyContent title={'Список моделей порожній'} />}
        </>
      </div>
    </Suspense>
  );
};

export default memo(ModelsList);
